import {
  REQUEST_CHARGE,
  RECEIVE_CHARGE,
  RECEIVE_ERROR
} from "../actions/charge";

const initialState = {
  isLoading: true,
  charge: {},
  error: undefined
};

export default function chargeReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_CHARGE:
      return { ...state, isLoading: true, charge: { uuid: action.uuid } };
    case RECEIVE_CHARGE:
      return { ...state, isLoading: false, charge: action.charge };
    case RECEIVE_ERROR:
      return { ...state, isLoading: false, error: action.message };
    default:
      return state;
  }
}
